var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReciever(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 100,
    fill: "url(#paint0_linear_2269_8005)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.403 122.299V140.139C145.404 141.416 144.92 142.646 144.049 143.581C143.178 144.515 141.986 145.085 140.711 145.174C138.507 145.325 136.706 145.406 135.313 145.406C90.7296 145.406 54.5914 109.268 54.5914 64.6842C54.5914 63.2918 54.6671 61.4907 54.8235 59.2859C54.9129 58.0118 55.4823 56.8189 56.4168 55.9481C57.3512 55.0774 58.5812 54.5934 59.8585 54.594H77.698C78.3238 54.5934 78.9275 54.8254 79.3918 55.2449C79.8561 55.6645 80.1479 56.2416 80.2105 56.8643C80.3265 58.0247 80.4325 58.9479 80.5334 59.6492C81.536 66.6464 83.5907 73.4518 86.6279 79.8347C87.1072 80.8437 86.7944 82.0495 85.8863 82.6953L74.9989 90.4748C81.6557 105.986 94.0167 118.347 109.528 125.004L117.297 114.136C117.615 113.692 118.078 113.374 118.606 113.237C119.135 113.099 119.694 113.152 120.188 113.385C126.57 116.416 133.374 118.466 140.368 119.464C141.07 119.565 141.993 119.676 143.143 119.787C143.765 119.851 144.341 120.143 144.759 120.607C145.178 121.071 145.409 121.674 145.408 122.299H145.403Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2269_8005",
    x1: 50.6473,
    y1: -26.3282,
    x2: 240.142,
    y2: 135.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReciever);
export default __webpack_public_path__ + "static/media/reciever.d33fc6e3314c29aade3370e8250548a7.svg";
export { ForwardRef as ReactComponent };